
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[storeId]",
      function () {
        return require("private-next-pages/stores/[storeId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[storeId]"])
      });
    }
  